import type { QuestionnaireName } from '../../common/enums/QuestionnaireName';
import { questionsPerQuestionnaireStep } from '../../common/enums/QuestionnaireName';

export function calculateProgressForProgressBar(answers?: number, questions?: number) {
    if (!answers || !questions) {
        return 0;
    }

    return Math.round((answers / questions) * 100);
}

export function findCurrentPage(questionnaireName: QuestionnaireName, answers?: number) {
    if (!answers) {
        return 1;
    }

    return Math.ceil(answers / questionsPerQuestionnaireStep[questionnaireName]);
}
